<template>
  <load-area v-if="providers == null"></load-area>
  <div class="row" v-if="providers != null">
    <div class="col-auto" style="min-width:300px">
      <div class="card">
        <div class="card-body p-0">
          <cardHead :title="'Reports'"></cardHead>
          <load-area v-if="reportProcess"></load-area>
          <div class="treeViewInput m-0" v-if="!reportProcess">
            <div class="borderNo">
              <ul>
                <template v-for="up in data.Providers" :key="up.Id">
                  <li>
                    <input
                      type="checkbox"
                      :id="'groups' + up.Id"
                      class="filled-in chk-col-teal"
                      :checked="up.Id == model.ProviderId"
                      @change="
                        model.ProviderId = up.Id;
                        model.CustomerProviderId = null;
                      "
                    />
                    <label :for="'groups' + up.Id">
                      {{ up.Name }}
                      <b class="badge badge-info">{{ up.ErrorCount }}</b>
                    </label>
                    <!-- <i v-if="up.CustomerProviders.length>0" class="fas fa-plus-circle"></i> -->
                    <ul class="open" v-if="up.Id == model.ProviderId">
                      <template
                        v-for="item in up.CustomerProviders"
                        :key="item.Id"
                      >
                        <li>
                          <input
                            type="checkbox"
                            :id="'groups' + item.Id"
                            class="filled-in chk-col-teal"
                            :checked="item.Id == model.CustomerProviderId"
                            @change="model.CustomerProviderId = item.Id"
                          />
                          <label :for="'groups' + item.Id">
                            {{ item.Username }}
                            <b class="badge badge-info">{{
                              item.ErrorCount
                            }}</b>
                          </label>
                        </li>
                      </template>
                    </ul>
                  </li>
                </template>
              </ul>
            </div>
          </div>
          <p
            class="p-20 tcenter"
            v-if="data != null && data.Providers.length == 0 && !reportProcess"
          >
            Hiç veri yok.
          </p>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="card">
        <div class="card-body p-0">
          <cardHead
            :title="'Scan Errors'"
            :buttons="[
              {
                title: 'Truncate',
                icon: 'fas fa-stop-circle',
                emit: 'Truncate',
              },
            ]"
            @truncate="truncate"
          ></cardHead>
          <Form
            method="dialog"
            v-slot="{ errors }"
            class="floating-labels row  p-20 p-b-10"
            ref="form"
          >
            <div class="col">
              <searchSelect
                :title="'ProviderId'"
                v-model="model.ProviderId"
                :errors="errors"
                @change="model.CustomerProviderId = null"
                :data="
                  $orderByArray(
                    providers.map((x) => {
                      return {
                        value: x.Id,
                        text: x.Name,
                      };
                    }),
                    'Name',
                    false,
                    false
                  )
                "
              >
              </searchSelect>
            </div>
            <div class="col">
              <formGroup
                :title="'StartDate'"
                :type="'date'"
                :max="model.EndDate"
                v-model="model.StartDate"
                :errors="errors"
                @keydown.enter="get"
              ></formGroup>
            </div>
            <div class="col">
              <formGroup
                :title="'EndDate'"
                :type="'date'"
                :min="model.StartDate"
                v-model="model.EndDate"
                :errors="errors"
                @keydown.enter="get"
              ></formGroup>
            </div>
            <div class="col-auto">
              <Btn
                class="btn-success"
                @click="get()"
                :disabled="data == null"
                :process="data == null"
                >Get</Btn
              >
            </div>
          </Form>
          <dataTable
            :name="'kolayrezScanErrors'"
            v-if="data != null"
            ref="agGrid"
            :columnDefs="columnDefs"
            :data="data.Items"
            @cellClicked="showShow = $event?.data?.LogFile"
          ></dataTable>
          <load-area v-if="data == null" class="border-top"></load-area>
        </div>
      </div>
      <show
        v-if="showShow != null"
        :logFile="showShow"
        @close="showShow = null"
        @reload="reload"
      ></show>
    </div>
  </div>
</template>

<script>
import show from "./show";
import moment from "moment";
export default {
  name: "ScanErrors",
  components: { show },
  data() {
    return {
      providers: null,
      columnDefs: [
        {
          headerName: "Id",
          width: 80,
          field: "Id",
          filter: "agNumberColumnFilter",
          sortable: true,
          cellClick: true,
          enableRowGroup: false,
        },
        {
          headerName: "CustomerId",
          field: "CustomerId",
          filter: "agNumberColumnFilter",
          width: 150,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "CustomerProviderId",
          field: "CustomerProviderId",
          filter: "agNumberColumnFilter",
          width: 150,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "ProviderId",
          field: "CustomerId",
          filter: "agNumberColumnFilter",
          width: 150,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "ProviderName",
          field: "ProviderName",
          filter: "agTextColumnFilter",
          flex: 1,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Username",
          field: "Username",
          filter: "agTextColumnFilter",
          flex: 1,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Date",
          field: "Date",
          filter: "agTextColumnFilter",
          width: 150,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
          valueFormatter: function(params) {
            let diff = new Date().getTimezoneOffset();
            return moment(
              new Date(params.value).setMinutes(
                new Date(params.value).getMinutes() - diff
              )
            ).format("DD.MM.YYYY HH:mm");
          },
        },
      ],
      data: null,
      showShow: null,
      model: {
        ProviderId: null,
        StartDate: null,
        EndDate: null,
        CustomerProviderId: null,
      },
      reportProcess: true,
      report: [],
    };
  },
  created() {
    this.$appAxiosAdmin
      .get(`kolayrez/providers?OnlyName=true`)
      .then((response) => {
        this.providers = response.data;
      });
    // this.getReport();
    this.get();
  },
  watch: {
    // showShow() {
    //   window.open(
    //     "https://reservations.ams3.digitaloceanspaces.com/logs/" +
    //       this.showShow,
    //     "_blank" // <- This is what makes it open in a new window.
    //   );
    // },
  },
  methods: {
    test() {
      alert("test");
    },
    get() {
      this.data = null;
      this.reportProcess = true;
      this.$appAxiosAdmin
        .post(`KOLAYREZ/ScanErrors/Filter`, this.model)
        .then((response) => {
          this.data = response.data;
          this.reportProcess = false;
        });
    },
    reload() {
      this.get();
    },
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning",
        text:
          "Are you sure you want to delete the operator named " +
          item.Name +
          "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`Operators/` + item.Id)
            .then(() => {
              this.$refs.agGrid.removeRow([item]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The operator was successfully deleted.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
    truncate() {
      this.$swal({
        icon: "question",
        title: "Warning",
        text: "Are you sure you want to truncate scans?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .get(`KOLAYREZ/ScanErrors/Truncate`)
            .then(() => {
              this.reload();
              this.$swal({
                icon: "success",
                title: "Success",
                text: "The successfully truncated.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>
<style scoped>
.report li {
  border-left: none !important;
  border-right: none !important;
}
.report li:first-child {
  border-top: none !important;
}
.treeViewInput > div > ul {
  height: unset;
}
</style>
